export default function setFocusAnchor(wishlistItemElement) {
    if (wishlistItemElement && wishlistItemElement.parentElement) {
        document.querySelectorAll('[data-focus-anchor]').forEach(el => el.removeAttribute('data-focus-anchor'));

        if (wishlistItemElement.parentElement.nextElementSibling?.querySelector('.product-card')) {
            wishlistItemElement.parentElement.nextElementSibling.querySelector('.product-card').setAttribute('data-focus-anchor', '');
        } else if (wishlistItemElement.parentElement.previousElementSibling?.querySelector('.product-card')) {
            wishlistItemElement.parentElement.previousElementSibling.querySelector('.product-card').setAttribute('data-focus-anchor', '');
        }
    }
};